export default __webpack_public_path__ + "static/media/add_vocabulary_dark.3cf923bb.png";